import { stringifyUrl } from "query-string";
import type { TxReceiptParams, TxReceiptResult } from "./type";
import { normalizeResponse } from "../../api/_helpers";

export async function fetchTxReceipt(options: TxReceiptParams) {
  const url = "/web3proxy/txReceipt";
  const endpoint = stringifyUrl({ url, query: options });

  return await normalizeResponse<TxReceiptResult, TxReceiptResult>(
    fetch(endpoint),
    (data) => {
      return data;
    }
  );
}
